import { StrapiStore } from "~/shared-types";
import { SectionHeading } from "~/components/SectionHeading";
import { StoreListCard } from "~/components/StoreListCard";
import { useWithFetchAll } from "~/api/useWithFetchAll";
import { useStoresQuery } from "~/api/stores";
import { useEffect } from "react";

const StoresPage = () => {
  const { data, fetchAllPages } = useWithFetchAll(
    useStoresQuery({ sortKey: "id", sortDirection: "desc" })
  );

  useEffect(() => {
    fetchAllPages();
  }, []);

  const stores = data?.pages
    .flatMap((page) => page?.data)
    .filter(Boolean) as StrapiStore[];

  return (
    <>
      <SectionHeading>
        <SectionHeading.Title className="mb-5">Producenter</SectionHeading.Title>
      </SectionHeading>
      <div className="mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {stores.map((store) => (
          <StoreListCard key={store.id} store={store} />
        ))}
      </div>
    </>
  );
};

export default StoresPage;
